module.exports = __webpack_public_path__ + "static/media/watermark.c69f867c.png";